<app-table [(data)]="data" [tableActions]="tableRowsActions" [tableIndications]="tableIndications"
    (onRowSelectionChange)="onRowSelectionChange($event)" (onAllRowSelectionChange)="onAllRowSelectionChange($event)"
    [columnsDefinition]="displayedColumnsLabel" [pageSize]="pageSize" [length]="paginatorLength" [pageIndex]="pageIndex"
    [configKey]="configKey" [highlights]="highlights" [onExport]="onExport" (onSortChange)="onSortChange($event)"
    [serverPagination]="serverPagination" [onExportDataSourceAvailable]="onExportDataSourceAvailable"
    (onPageChange)="onPageChange($event)" [onDataSourceChanged]="onDataSourceChanged" [exportFileName]="exportFileName"
    [onClearFilters]="onClearFilters" [onFiltersCleared]="onFiltersCleared" [onExportExcelCaller]="onExportExcelCaller"
    [showClearFilterButton]="showClearFilterButton" [showFilter]="showFilter" ngDefaultControl>

    <div class="row col" *ngIf="isAllSelected && paginatorLength > pageSize">
        <div class="alert alert-warning">Vous avez selectionné la totalité des <strong>{{paginatorLength}}</strong>
            factures.</div>
    </div>

    <div class="row col" mass-actions>
        <div *ngIf="canDownload && selectedIds?.length > 0">
            <button type="button" class="btn btn-secondary btn-sm" tooltip="Télécharger les factures"
                (click)="onMassDownload()">
                <span class="material-icons">cloud_download</span>
            </button>
        </div>
        <div *ngFor="let massAction of tableMassActions" class="massaction-button">
            <div *ngIf="selectedIds?.length > 0 && massAction.Filter(selectedIds)">
                <button type="button" class="btn btn-secondary btn-sm" (click)="massAction.Handler(selectedIds)">
                    <span class="material-icons" [tooltip]="massAction.Tooltip">{{massAction.Icon}}</span>
                </button>
            </div>
        </div>
    </div>
</app-table>